import { AssignmentMeta } from '../assignment';

export interface Invite {
  _id: string;
  createdAt: number;
  type: 'realtimeAssignment'; // for now we only have realtime invites
  title: string;
  assignmentId: string;
  userId: string;
}

export namespace Invite {
  export function createId(assignmentId: string, userId: string): string {
    return `${assignmentId}-${userId}`;
  }

  export function create(meta: AssignmentMeta, userId: string): Invite {
    return {
      _id: createId(meta._id, userId),
      assignmentId: meta._id,
      userId,
      title: meta.assignmentInfo.name || '',
      type: 'realtimeAssignment',
      createdAt: Date.now(),
    };
  }
}

export interface ValidatedInvite {
  invite: Invite;
  metaWithSettings: AssignmentMeta.WithSettings;
}
